import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { RoleSimpleForm } from 'domains/Role/components'
import { Button, Title } from '@qonsoll/react-design'
import { Form, Input } from 'antd'
import { KEYS } from '__constants__'
import {
  useInitializeRoleAdvancedForm,
  useActionsRoleAdvancedForm
} from './hooks'
import { CustomerSelectWithCreate } from 'domains/Customer/components'

const RoleAdvancedForm = (props) => {
  const { initialData, group, showTitle } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const { form } = useInitializeRoleAdvancedForm(initialData)

  // [HANDLERS]
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      onFinish()
    }
  }

  const { loading, onFinish, onReset } = useActionsRoleAdvancedForm({
    initialData,
    form
  })

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Role')}
        </Title>
      )}
      <RoleSimpleForm showTitle={false} group={[...group, 'role']} />
      <Form.Item name={[group, 'customerId']}>
        <CustomerSelectWithCreate />
      </Form.Item>
    </>
  ) : (
    <Form
      onKeyPress={handleKeyPress}
      onFinish={onFinish}
      layout="vertical"
      autoComplete="off"
      form={form}>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Role')}
        </Title>
      )}
      <RoleSimpleForm group={['role']} />
      <Form.Item name={['customerId']}>
        <CustomerSelectWithCreate />
      </Form.Item>
      <Button mr={2} htmlType="button" onClick={onReset} mb={4}>
        {t('Cancel')}
      </Button>
      <Button type="primary" loading={loading} onClick={() => form.submit()}>
        {t('Save')}
      </Button>
    </Form>
  )
}

RoleAdvancedForm.propTypes = {
  initialData: PropTypes.object,
  group: PropTypes.array,
  showTitle: PropTypes.bool
}

export default RoleAdvancedForm
